import React from 'react';
import { ButtonSquareGroup } from '@yme/atoms/button-select/ButtonSquareGroup';
import { ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, } from '@yme/pdp-components/ProductCard/components/ProductFilter/constants';
import { SortFieldsWithNumbers } from '@yme/pdp-components/ProductCard/components/ProductFilter/productOptions/helpers';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { BOATS_PRODUCT_OPTION_DATA_TEST_ID, useCommonProductOptions } from '../productOptions';
export function SelectLength({ productFilterOptions, variantsOfProduct, }) {
    const { t } = useTranslation();
    const { onSelectNewValue, possibleOptions, allVariants, productOption, isProductOptionsFilterExist, } = useCommonProductOptions({
        productFilterOptions,
        variantsOfProduct,
    });
    if (isProductOptionsFilterExist) {
        const sortedProductOptionList = SortFieldsWithNumbers(allVariants);
        return (React.createElement(FlexWrapper, { mt: "24px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px", gap: "4px" },
                React.createElement(RegularTextLevel3, { as: "span", weight: 500 }, t('productCard_length_label'))),
            React.createElement(FlexWrapper, { flexDirection: "row", gap: "8px", flexWrap: "wrap", minHeight: "44px", mb: "16px" },
                React.createElement(ButtonSquareGroup, { contentTag: RegularTextLevel4, defaultContentStyles: DEFAULT_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, activeContentStyles: ACTIVE_CONTENT_STYLES_FOR_FILTER_RADIO_BUTTON, setActiveOption: onSelectNewValue, allOptions: sortedProductOptionList, possibleOptions: possibleOptions, selectedValue: productOption, dataTestId: BOATS_PRODUCT_OPTION_DATA_TEST_ID, isShowDisabled: true }))));
    }
    return null;
}
